import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import * as S from './styles';

const CondominiumNotice = ({ notice }) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.Container>
      <S.Text>
        <S.Title>{t('condominium-notice.title')}</S.Title>
        {` ${notice}`}
      </S.Text>
    </S.Container>
  );
};

CondominiumNotice.propTypes = {
  notice: propTypes.string.isRequired,
};

export default CondominiumNotice;
